import { render } from "./OrderViewPage.vue?vue&type=template&id=23a8268d&scoped=true"
import script from "./OrderViewPage.vue?vue&type=script&lang=js"
export * from "./OrderViewPage.vue?vue&type=script&lang=js"

import "./OrderViewPage.vue?vue&type=style&index=0&id=23a8268d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-23a8268d"

export default script